<template> 
  <div>
    <b-modal v-model="modalShow" @hidden="$emit('hidden')" size="xl">
      <template #modal-header="{ close }">
        <div class="d-flex align-items-center flex-fill">
          <h5 class="mb-0">Importação CNIS</h5>

          <b-button class="ml-auto" size="sm" variant="link" @click="close()">
            <i class="fa fa-times" aria-hidden="true"></i>
          </b-button>
        </div>
      </template>

      <template #default>
        <div class="row">
          <div class="col-12 mb-3">
            <input type="file" @change="onChangeFile" accept=".pdf" class="form-control" />
          </div>
          <div class="col-12 mb-3">
            <b-checkbox v-model="addMissingMonths">Adicionar salários para remunerações ausentes</b-checkbox>
          </div>
          <div class="col-12 mb-3">
            <b-checkbox v-model="limitRPPSMaxSalary">Limitar teto salarial para indicadores RPPS</b-checkbox>
          </div>
          <div class="col-12">
            <b-button @click="importCnis" variant="primary">Extrair Dados</b-button>
          </div>
        </div>
        <div class="mt-4">
          <div v-if="registers.length > 0">
            <div v-for="register in registers" :key="register.seq" class="mb-4">
              <div class="d-flex align-items-center mb-3 cursor-pointer" @click="toggleRegister(register)">
                <i class="fas mr-2" :class="register.isOpen ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                <h5 class="mb-0">{{ register.seq }} - {{ register.name }}
                  <span v-if="register.indicatorsHeader" class="text-red"> - [INDICADOR - {{ register.indicatorsHeader }}]</span> -
                  ({{ register.initialDate || "Data inicial não definida" }} - {{ register.finalDate ||
                    register.lastRemuneration && `Última Remuneração:
                  ${register.lastRemuneration}` || "Data final não definida" }}) {{ hasWarning(register.salaries) &&
                    '[Aviso]' }}
                </h5>
              </div>

              <table v-if="register.isOpen" class="table table-bordered">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Valor</th>
                    <!-- <th>Valor Original</th> -->
                    <th>Valor Atualizado</th>
                    <th>Avisos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="salary in register.salaries" :key="salary.yearMonth">
                    <td>{{ salary.yearMonth }}</td>
                    <td>{{ salary.value }}</td>
                    <!-- <td>{{ salary.originalValue }}</td> -->
                    <td>{{ salary.updatedValue }}</td>
                    <td>
                      <div v-for="warning in salary.warnings" :key="warning">
                        {{ warning }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- <div v-else class="p-4 text-center">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
          <h6 class="mb-0 mt-2 font-weight-bold text-gray-600">Carregando informações...</h6>
        </div> -->
      </template>

      <template #modal-footer="{ cancel }">
        <b-button v-on:click="save" variant="primary">
          <b-spinner v-if="isSaving" small variant="white"></b-spinner>
          Importar Dados
        </b-button>

        <b-button variant="outline-primary" @click="cancel()">
          Fechar
        </b-button>
      </template>
    </b-modal>

    <!-- Modal de confirmação para duplicatas -->
    <b-modal v-model="showDuplicateModal" title="Sequências Duplicadas Encontradas" size="md">
      <template #default>
        <div class="alert alert-warning">
          <h6>Os seguintes itens do CNIS já foram importados:</h6>
          <ul class="mb-0">
            <li v-for="seq in duplicateSeqs" :key="seq">Seq. {{ seq }}</li>
          </ul>
          <p class="mt-3 mb-0">
            Deseja prosseguir com a importação mesmo assim? Isso pode resultar em dados duplicados.
          </p>
        </div>
      </template>

      <template #modal-footer="{ cancel }">
        <b-button variant="outline-primary" @click="cancelImport()">
          Cancelar
        </b-button>
        <b-button variant="primary" @click="proceedWithImport()">
          Prosseguir
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BIcon } from 'bootstrap-vue'
import InputDatePicker from '@/components/InputDatePicker.vue';
import VueMonthlyPicker from 'vue-monthly-picker'
import * as pdfjsLib from "pdfjs-dist/build/pdf";
import "pdfjs-dist/build/pdf.worker.entry";
import axios from 'axios';
import moment from 'moment';
export default {
  name: 'ModalImportCnisForm',
  components: { BIcon, InputDatePicker, VueMonthlyPicker },
  props: {
    updateIndex: {
      type: Array,
      required: true,
    },
    parentId: {
      type: String,
    },
  },

  async created() {
    await this.loadExistingWorkRecords();
  },

  data: () => ({
    cnisFile: null,
    registers: [],
    modalShow: true,
    isLoading: false,
    isSaving: false,
    addMissingMonths: false,
    limitRPPSMaxSalary: false,
    existingWorkRecords: [],
    duplicateSeqs: [],
    showDuplicateModal: false,
  }),

  computed: {

  },

  methods: {
    async loadExistingWorkRecords() {
      try {
        const response = await axios.get(`/calculations/${this.parentId}/work-records`);
        this.existingWorkRecords = response.data.workRecords || [];
      } catch (error) {
        console.error('Erro ao carregar work records existentes:', error);
        this.existingWorkRecords = [];
      }
    },

    extractSeqFromCompanyName(companyName) {
      const match = companyName.match(/Seq\.\s*(\d+)/);
      return match ? match[1] : null;
    },

    checkForDuplicates() {
      const existingSeqs = this.existingWorkRecords
        .map(record => this.extractSeqFromCompanyName(record.companyName))
        .filter(seq => seq !== null);

      const importedSeqs = this.registers
        .map(register => this.extractSeqFromCompanyName(register.seq))
        .filter(seq => seq !== null);

      this.duplicateSeqs = importedSeqs.filter(seq => existingSeqs.includes(seq));
      
      return this.duplicateSeqs.length > 0;
    },

    hasWarning(salaries) {
      return salaries.find(salary => salary.warnings.length > 0);
    },

    async save() {
      this.isSaving = true;

      if (this.registers.length === 0) {
        this.$toast.open({
          message: 'Nenhuma remuneração encontrada, por favor, clique em "Extrair Dados" ou selecione um arquivo válido.',
          type: 'info',
          position: 'top-right'
        });
        this.isSaving = false;
        return;
      }

      // Verificar duplicatas antes de salvar
      if (this.checkForDuplicates()) {
        this.showDuplicateModal = true;
        this.isSaving = false;
        return;
      }

      await this.performSave();
    },

    async performSave() {
      this.isSaving = true;

      let workRecords = [];
      this.registers.forEach(register => {
        let salaries = register.salaries.map(salary => {
          const salaryDate = `01/${salary.yearMonth}`;
          if (moment(salaryDate, 'DD/MM/YYYY', true).isBefore('1994-07-01')) {
            return null;
          }

          const month = salary.yearMonth.split('/')[0];
          const year = salary.yearMonth.split('/')[1];
          const value = parseFloat(salary.value.replace('R$', '').trim().replace('.', '').replace(',', '.'));
          const originalValue = parseFloat((salary.originalValue || salary.value).replace('R$', '').trim().replace('.', '').replace(',', '.'));
          const updateIndex = this.updateIndex.find(index => index.month === month && index.year === year)?.index || 1;
          const warningsTags = salary.warningsTags;
          return {
            month: month,
            year: year,
            value: value,
            originalValue: originalValue,
            update: updateIndex,
            updatedValue: value * updateIndex,
            warnings: warningsTags
          };
        });

        salaries = salaries.filter(salary => salary);

        const companyName = register.name ? `${register.seq} - ${register.name}` : register.seq;

        const indicators = (register.indicatorsHeader && register.indicatorsHeader.trim()) ? register.indicatorsHeader.trim() : null

        const regimeType = indicators?.includes('RPPS') ? 'RPPS' : 'RGPS';

        workRecords.push({
          companyName: companyName,
          egressDate: register.finalDate || register.lastRemuneration || register.initialDate,
          ingressDate: register.initialDate,
          calculationId: this.parentId,
          indicators,
          salaries: salaries,
          regimeType
        });
      });

      try {
        await axios.post('/work-records/multiple', { workRecords });
      } catch (err) {
        this.$toast.open({
          message: 'Erro ao importar',
          type: 'error',
          position: 'top-right'
        });
      }

      this.isSaving = false;

      this.$emit('save');
      this.$emit('hidden');
    },

    proceedWithImport() {
      this.showDuplicateModal = false;
      this.performSave();
    },

    cancelImport() {
      this.showDuplicateModal = false;
      this.isSaving = false;
    },
    onChangeFile(event) {
      this.cnisFile = event.target.files[0];
    },
    importCnis() {
      if (this.cnisFile) {
        this.getTextFromFile(this.cnisFile);
      }
    },
    getTextFromFile(file) {
      let reader = new FileReader();
      reader.onload = () => {
        let fileContent = new Uint8Array(reader.result);
        fileToPdf(fileContent).then((pdf) => {
          pdfToText(pdf).then((text) => {
            this.registers = parseImportedSalaries(
              text,
              this.updateIndex,
              this.addMissingMonths,
              this.limitRPPSMaxSalary
            );
          });
        });
      };
      reader.readAsArrayBuffer(file);
    },
    toggleRegister(register) {
      register.isOpen = !register.isOpen;
    }
  },
}

function groupByYearMonth(input) {
  return Object.values(input.reduce((grouped, { yearMonth, value, warnings = [], warningsTags = [] }) => {
    const numericValue = parseFloat(value.replace(".", "").replace(",", "."));

    if (!grouped[yearMonth]) {
      grouped[yearMonth] = { yearMonth, value: 0, values: [], warnings: [], warningsTags: [] };
    }

    grouped[yearMonth].value += numericValue;
    grouped[yearMonth].values.push(`R$ ${value}`);
    grouped[yearMonth].warnings.push(...warnings);
    grouped[yearMonth].warningsTags.push(...warningsTags);

    return grouped;
  }, {})).map(({ yearMonth, value, values, warnings, warningsTags }) => {
    const formattedValue = `R$ ${value.toFixed(2).replace(".", ",")}`;
    if (values.length > 1) {
      warnings.push(`Valor atualizado para ${formattedValue}. Motivo: ${values.length} salários com mesma data. Valores originais: ${values.join(", ")}.`);
    }
    return { yearMonth, value: formattedValue, warnings, warningsTags };
  });
}

/** Detecta modelo de CNIS STD 2 (layout com "Seq.   NIT" e "Competência   Remuneração   Indicadores"). */
function isStd2CnisFormat(text) {
  return /Seq\.\s+NIT\s+\d+\s+\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}/.test(text) &&
    /Competência\s+Remuneração\s+Indicadores/i.test(text);
}

/** CNPJ/identificador no STD 2: padrão 00.000.000/0000-00 ou 00.000.00000/00 (contrib. individual). */
const std2CnpjPattern = '(?:\\d{2}\\.\\d{3}\\.\\d{3}\\/\\d{4}-\\d{2}|\\d{2}\\.\\d{3}\\.\\d{5}\\/\\d{2})';

function parseImportedSalaries(importedText, updateIndexes = [], addMissingMonths = false, limitRPPSMaxSalary = false) {
  if (isStd2CnisFormat(importedText)) {
    return parseImportedSalariesStd2(importedText, updateIndexes, addMissingMonths, limitRPPSMaxSalary);
  }
  return parseImportedSalariesStd1(importedText, updateIndexes, addMissingMonths, limitRPPSMaxSalary);
}

function parseImportedSalariesStd2(importedText, updateIndexes, addMissingMonths, limitRPPSMaxSalary) {
  const birthDateMatch = importedText.match(/Data de nasciment[oa]:\s*(\d{2}\/\d{2}\/\d{4})/i);
  const birthDate = birthDateMatch ? birthDateMatch[1] : null;

  // Normaliza quebras de linha para facilitar regex (layout PDF pode vir com itens em linhas separadas)
  const normalized = importedText.replace(/\r?\n/g, ' ').replace(/\s{2,}/g, ' ').trim();

  // Blocos: "Seq.   NIT   número   CNPJ   nome   Empregado/Contribuinte   datas   indicadores   ... Remunerações   MM/YYYY   valor ..."
  const endOfInput = '\\$';
  const blockRegex = new RegExp(
    `Seq\\.\\s+NIT\\s+(\\d+)\\s+(${std2CnpjPattern})\\s+([\\s\\S]*?)(?=Seq\\.\\s+NIT\\s+\\d+\\s+${std2CnpjPattern}|Legenda\\s+de\\s+Indicadores|${endOfInput})`,
    'gi'
  );
  const dateRegex = /\b(\d{2}\/\d{2}\/\d{4})\b/g;
  const salaryRegexStd2 = /(\d{2}\/\d{4})\s+([\d.]+,\d{2})/g;
  const registers = [];
  let blockMatch;

  while ((blockMatch = blockRegex.exec(normalized)) !== null) {
    const seqNum = blockMatch[1];
    const cnpj = blockMatch[2];
    const rest = blockMatch[3];

    const nameMatch = rest.match(/^([\s\S]*?)\s+(Empregado|Contribuinte Individual)\s+([\s\S]*)/i);
    const name = nameMatch ? nameMatch[1].trim().replace(/\s+/g, ' ') : '';
    const afterType = nameMatch ? nameMatch[3] : rest;

    const indicatorsHeaderMatch = afterType.match(/(PRPPS|PVIN-RE|PREC-MENOR-MIN|[A-Z]{3,}-[A-Z]{2,}(?:,\s*[A-Z]{3,}-[A-Z]{2,})*)/);
    const indicatorsHeader = indicatorsHeaderMatch ? indicatorsHeaderMatch[1].trim() : '';

    const dateCandidates = [...afterType.matchAll(dateRegex)].map(m => m[1]);
    const filteredDates = birthDate ? dateCandidates.filter(d => d !== birthDate) : dateCandidates;
    const initialDate = filteredDates[0] || '';
    let finalDate = filteredDates[1] || '';
    if (finalDate && moment(finalDate, 'DD/MM/YYYY').isBefore(moment(initialDate, 'DD/MM/YYYY'))) {
      finalDate = null;
    }

    const salaries = [];
    let m;
    salaryRegexStd2.lastIndex = 0;
    while ((m = salaryRegexStd2.exec(afterType)) !== null) {
      const yearMonth = m[1];
      const value = m[2];
      // Valor só numérico (ex: "96.449,91"), como no padrão 1, para groupByYearMonth fazer parseFloat corretamente
      salaries.push({
        yearMonth,
        value,
        warnings: [],
        warningsTags: []
      });
    }

    const isRPPSIndicator = indicatorsHeader.includes('RPPS');
    if (initialDate && finalDate && addMissingMonths) {
      for (let mo = moment(initialDate, 'DD/MM/YYYY').startOf('month');
        mo.isBefore(moment(finalDate, 'DD/MM/YYYY').endOf('month'));
        mo.add(1, 'month')) {
        if (!salaries.find(s => s.yearMonth === mo.format('MM/YYYY'))) {
          salaries.push({
            yearMonth: mo.format('MM/YYYY'),
            value: '0,00',
            warnings: ['Remuneração ausente.'],
            warningsTags: []
          });
        }
      }
    }
    salaries.forEach(s => {
      if (moment(`01/${s.yearMonth}`, 'DD/MM/YYYY').isBefore('1994-07-01')) {
        s.warnings.push('Salário será desconsiderado, pois foi anterior a 01/07/1994.');
      }
    });

    const grouped = groupByYearMonth(salaries).map(s => {
      const [month, year] = s.yearMonth.split('/');
      const upd = updateIndexes.find(ui => ui.month === month && ui.year === year) || {};
      const originalVal = parseFloat(s.value.replace('R$', '').trim().replace(/\./g, '').replace(',', '.'));
      let val = originalVal;
      if (upd.min_salary && val < upd.min_salary) {
        s.warnings.push(`Valor atualizado para R$ ${upd.min_salary.toFixed(2).replace('.', ',')}. Motivo: Valor menor que salário mínimo. Valor original: ${s.value}.`);
        s.warningsTags.push('MIN_SALARY');
        s.value = `R$ ${upd.min_salary.toFixed(2).replace('.', ',')}`;
        val = upd.min_salary;
      }
      if (upd.max_salary && val > upd.max_salary && (limitRPPSMaxSalary || !isRPPSIndicator)) {
        s.warnings.push(`Valor atualizado para R$ ${upd.max_salary.toFixed(2).replace('.', ',')}. Motivo: Valor maior que teto salarial. Valor original: ${s.value}.`);
        s.warningsTags.push('MAX_SALARY');
        s.value = `R$ ${upd.max_salary.toFixed(2).replace('.', ',')}`;
        val = upd.max_salary;
      }
      const updVal = val * (upd.index || 1);
      return {
        ...s,
        originalValue: `R$ ${originalVal.toFixed(2).replace('.', ',')}`,
        update: upd.index || 1,
        updatedValue: `R$ ${updVal.toFixed(2).replace('.', ',')}`
      };
    });

    registers.push({
      seq: `Seq. ${seqNum}`,
      cnpj,
      name,
      indicatorsHeader,
      initialDate,
      finalDate,
      lastRemuneration: salaries.length
        ? moment(`01/${salaries[salaries.length - 1].yearMonth}`, 'DD/MM/YYYY').endOf('month').format('DD/MM/YYYY')
        : '',
      salaries: grouped,
      isOpen: false
    });
  }
  return registers;
}

function parseImportedSalariesStd1(importedText, updateIndexes = [], addMissingMonths = false, limitRPPSMaxSalary = false) {
  // --- 1) extract birth date so we can ignore it for initialDates ---
  const birthDateMatch = importedText.match(/Data de nasciment[oa]:\s*(\d{2}\/\d{2}\/\d{4})/i);
  const birthDate = birthDateMatch ? birthDateMatch[1] : null;

  const seqRegex = /Seq\.[\s\S]*?(?=Seq\.|$)/g;
  const dateRegex = /\b(?<date>\d{2}\/\d{2}\/\d{4})(?!\s+\d{2}:\d{2}:\d{2})\b/g;
  const salaryRegex = /(?<yearMonth>\d{2}\/\d{4})\s+(?:R\$\s)?(?<value>(?:\d{1,3}\.?)+,\d{2})/g;

  let registers = [];
  let seqIndex = 1;
  let seqMatch;

  while ((seqMatch = seqRegex.exec(importedText)) !== null) {
    const seqText = seqMatch[0];

    let indicatorsHeader = '';
    const indicatorsHeaderMatch = seqText.match(/Indicadores:\s*\n?([A-Z0-9\-.,\s]+)/i);
    if (indicatorsHeaderMatch) {
      indicatorsHeader = indicatorsHeaderMatch[1].trim().replace(/\s+/g, ' ');
      indicatorsHeader = indicatorsHeader.split(/\s+(?=Comp|Compet)/i)[0].trim();
    } else {
      const afterCNPJMatch = seqText.match(/(?:AUTÔNOMO|RECOLHIMENTO|EMPREGADOR|BENEFÍCIO|COOPERATIVAS|[A-Z]{2,}[\w\s.\/-]*?)\s+([A-Z]{4,}-[A-Z]{2,}(?:,\s*[A-Z]{4,}-[A-Z]{2,})*)/i);
      if (afterCNPJMatch) {
        indicatorsHeader = afterCNPJMatch[1].trim();
      }
    }

    let isRPPSIndicator = indicatorsHeader.includes('RPPS');

    // --- extract company/benefit/etc. ---
    const entryRegex = new RegExp([
      '(?<cnpj>\\d{2}\\.\\d{3}\\.\\d{3}(?:\\/\\d{4}-\\d{2})?|\\d{2}\\.\\d{3}\\.\\d{3})\\s*\\n+' +
      '(?<name>[A-Z0-9\\s\\/&.,\\-ÇÃÕÂÊÔÁÉÍÓÚÀÈÌÒÙ]+)',
      '|(?<benefit>\\d{3}\\.\\d{5}\\.\\d{2}-\\d)\\s*\\n+Benefício',
      '|(?<nit1>\\d{3}\\.\\d{5}\\.\\d{2}-\\d)\\s*\\n+EMPRESÁRIO \\/ EMPREGADOR',
      '|(?<nit2>\\d{3}\\.\\d{5}\\.\\d{2}-\\d)\\s*\\n+PERÍODO DE ATIVIDADE DE SEGURADO ESPECIAL',
      '|(?<nit3>\\d{3}\\.\\d{5}\\.\\d{2}-\\d)\\s*\\n+RECOLHIMENTO',
      '|(?<nit4>\\d{3}\\.\\d{5}\\.\\d{2}-\\d)\\s*\\n+AUTÔNOMO',
      '|(?<agrup>AGRUPAMENTO DE CONTRATANTES\\/COOPERATIVAS)'
    ].join(''), 'm');

    const entryMatch = entryRegex.exec(seqText) || {};
    let cnpj = null, name = '';
    if (entryMatch.groups) {
      if (entryMatch.groups.cnpj) {
        cnpj = entryMatch.groups.cnpj;
        name = entryMatch.groups.name;
      } else if (entryMatch.groups.benefit) {
        cnpj = entryMatch.groups.benefit;
        name = 'Benefício';
      } else if (entryMatch.groups.nit1) {
        cnpj = entryMatch.groups.nit1;
        name = 'EMPRESÁRIO / EMPREGADOR';
      } else if (entryMatch.groups.nit2) {
        cnpj = entryMatch.groups.nit2;
        name = 'PERÍODO DE ATIVIDADE DE SEGURADO ESPECIAL';
      } else if (entryMatch.groups.nit3) {
        cnpj = entryMatch.groups.nit3;
        name = 'RECOLHIMENTO';
      } else if (entryMatch.groups.nit4) {
        cnpj = entryMatch.groups.nit4;
        name = 'AUTÔNOMO';
      } else if (entryMatch.groups.agrup) {
        name = 'AGRUPAMENTO DE CONTRATANTES/COOPERATIVAS';
      }
    }
    name = (name || '').replace(/\s+/g, ' ').replace(/\s+E$/, '').trim();

    // --- extract & filter dates ---
    const dateCandidates = [...seqText.matchAll(dateRegex)].map(m => m.groups.date);
    const filteredDates = birthDate ? dateCandidates.filter(d => d !== birthDate) : dateCandidates;
    const initialDate = filteredDates[0] || '';
    let finalDate = filteredDates[1] || '';

    if (finalDate && moment(finalDate, 'DD/MM/YYYY').isBefore(moment(initialDate, 'DD/MM/YYYY'))) {
      finalDate = null;
    }

    // --- salaries extraction (custom for AGRUPAMENTO) ---
    let salaries = [];
    if (name === 'AGRUPAMENTO DE CONTRATANTES/COOPERATIVAS') {
      const lines = seqText.split(/\r?\n/).map(l => l.trim());
      for (let i = 0; i < lines.length; i++) {
        if (/^\d{2}\/\d{4}$/.test(lines[i])) {
          const date = lines[i];
          for (let j = i + 1; j < lines.length; j++) {
            if (/^\d{1,3}(?:\.\d{3})*,\d{2}$/.test(lines[j])) {
              salaries.push({ yearMonth: date, value: lines[j], warnings: [], warningsTags: [] });
              break;
            }
          }
        }
      }
    } else {
      salaries = [];

      let match;
      while ((match = salaryRegex.exec(seqText)) !== null) {
        let { yearMonth, value } = match.groups;

        let warnings = [];

        const contextBefore = seqText.slice(0, match.index);

        const mmYearMatches = [...contextBefore.matchAll(/\b\d{2}\/\d{4}\b/g)];

        if (mmYearMatches.length > 0) {
          const lastMMYYYY = mmYearMatches[mmYearMatches.length - 1][0];
          const before = seqText.slice(Math.max(0, match.index - 3), match.index);
          const cameFromDDMMYYYY = /^\d{2}\/$/.test(before);

          if (cameFromDDMMYYYY) {
            yearMonth = lastMMYYYY;
          }
        }

        const nextLines = seqText.slice(match.index).split('\n').slice(0, 4);
        for (const line of nextLines) {
          const indicatorMatch = line.match(/^[A-Z]{3,}(?:-[A-Z]{2,})?(?:,\s*[A-Z]{3,}(?:-[A-Z]{2,})?)*$/);
          if (indicatorMatch) {
            warnings.push(`Indicador associado: ${indicatorMatch[0]}`);
            break;
          }
        }
        salaries.push({
          yearMonth,
          value,
          warnings,
          warningsTags: []
        });
      }
    }

    if (initialDate && finalDate && addMissingMonths) {
      for (let m = moment(initialDate, 'DD/MM/YYYY').startOf('month');
        m.isBefore(moment(finalDate, 'DD/MM/YYYY').endOf('month'));
        m.add(1, 'month')) {
        if (!salaries.find(s => s.yearMonth === m.format('MM/YYYY'))) {
          salaries.push({ 
            yearMonth: m.format('MM/YYYY'), 
            value: '0,00', 
            warnings: ['Remuneração ausente.'], 
            warningsTags: [] 
          });
        }
      }
    }

    salaries.forEach(s => {
      if (moment(`01/${s.yearMonth}`, 'DD/MM/YYYY').isBefore('1994-07-01')) {
        s.warnings.push('Salário será desconsiderado, pois foi anterior a 01/07/1994.');
      }
    });

    const grouped = groupByYearMonth(salaries).map(s => {
      const [month, year] = s.yearMonth.split('/');
      const upd = updateIndexes.find(ui => ui.month === month && ui.year === year) || {};
      const originalVal = parseFloat(s.value.replace('R$', '').replace('.', '').replace(',', '.'));
      let val = originalVal;

      if (upd.min_salary && val < upd.min_salary) {
        s.warnings.push(`Valor atualizado para R$ ${upd.min_salary.toFixed(2).replace('.', ',')}. Motivo: Valor menor que salário mínimo. Valor original: ${s.value}.`);
        s.warningsTags.push('MIN_SALARY');
        s.value = `R$ ${upd.min_salary.toFixed(2).replace('.', ',')}`;
        val = upd.min_salary;
      }
      if (upd.max_salary && val > upd.max_salary && (limitRPPSMaxSalary || !isRPPSIndicator)) {
        s.warnings.push(`Valor atualizado para R$ ${upd.max_salary.toFixed(2).replace('.', ',')}. Motivo: Valor maior que teto salarial. Valor original: ${s.value}.`);
        s.warningsTags.push('MAX_SALARY');
        s.value = `R$ ${upd.max_salary.toFixed(2).replace('.', ',')}`;
        val = upd.max_salary;
      }

      const updVal = val * (upd.index || 1);
      return { 
        ...s, 
        originalValue: `R$ ${originalVal.toFixed(2).replace('.', ',')}`, 
        update: upd.index || 1, 
        updatedValue: `R$ ${updVal.toFixed(2).replace('.', ',')}`
      };
    });

    registers.push({
      seq: `Seq. ${seqIndex++}`,
      cnpj,
      name,
      indicatorsHeader,
      initialDate,
      finalDate,
      lastRemuneration: salaries.length
        ? moment(`01/${salaries[salaries.length - 1].yearMonth}`, 'DD/MM/YYYY').endOf('month').format('DD/MM/YYYY')
        : '',
      salaries: grouped,
      isOpen: false
    });
  }

  return registers;
}

function itemsToString(items) {
  return items.map(item => item.str).join("\n");
}

function fileToPdf(file) {
  return new Promise((resolve, reject) => {
    if (!pdfjsLib) {
      reject(new Error("pdfjsLib is undefined"));
      return;
    }

    pdfjsLib.GlobalWorkerOptions.workerSrc = "//mozilla.github.io/pdf.js/build/pdf.worker.mjs";

    pdfjsLib.getDocument(file).promise
      .then((pdf) => resolve(pdf))
      .catch((error) => reject(error));
  });
}

function pdfToText(pdf, pageNumber = 1) {
  return new Promise((resolve) => {
    if (pageNumber > pdf.numPages) {
      resolve("");
    } else {
      pdfToText(pdf, pageNumber + 1).then((nextPagesText) => {
        pdf.getPage(pageNumber).then((page) => {
          page.getTextContent().then((content) => {
            const pageText = itemsToString(content.items);
            resolve(pageText + nextPagesText);
          });
        });
      });
    }
  });
}

</script>

<style lang="scss">
.modal-remuneration-table {
  max-height: 60vh;
  overflow-y: auto;

  &__table {
    margin-bottom: 0;

    td,
    th {
      vertical-align: middle !important;
      display: table-cell !important;
      padding: 0.5rem 1.5rem !important;
    }
  }
}

.cursor-pointer {
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}
</style>
